// extracted by mini-css-extract-plugin
export default {"adminCard":"AdminCardPage_adminCard__ddlgA","container":"AdminCardPage_container__MOnaM","content":"AdminCardPage_content__qwp+T","btn":"AdminCardPage_btn__VfFzT"};